<template lang="html">
    <div class="overlay-menu" :class="{abierto: menu_abierto}" @click.self="cerrar_menu">
      <div class="side-menu" :style="{'background-color': bgcolor}">
        <div class="close" @click.self="cerrar_menu">X</div>
		<h2 class="encabezado">Contenidos incluidos:</h2>
        <div class="subcontenidos scroll-light" v-if="contenidos">
          <div  class="subcontenido" v-for="(contenido, index) in contenidos" :key="index">
            <div class="icono">{{contenido.tipo}}</div>
            <div class="titulo">{{contenido.nombre}}</div>
            <div class="btn btn-default" @click="lanzar(contenido)">Lanzar</div>
          </div>
        </div>
        <!-- <pre>{{contenidos}}</pre> -->
      </div>
    </div>
</template>

<script>
import isElectron from 'is-electron'
export default {
	name: 'SideBarMenu',
	props: {
		'eventBus': Object,
		'contenidos': Array,
		bgcolor: {
			type: String,
			default: function () {
				return "rgb(255, 125, 125)";
			}
		},
		color: {
			type: String,
			default: function () {
				return "white";
			}
		},
	},
	components: {},
	data: function () {
		return {
			menu_abierto: false
		}
	},
	computed: {},
	methods: {
		abrir_menu () {
			this.menu_abierto = true;
		},
		cerrar_menu () {
			this.menu_abierto = false;
		},
		lanzar (contenido) {
			console.log(contenido.ruta);
			if (isElectron()) {
				if(contenido.especial){
					const { shell } = require('electron');
					shell.openItem(contenido.ruta);
				}else{
					const open = require('open');
					open(contenido.ruta);
				}
			}
		}
	},
	created () { },
	mounted () {
		this.eventBus.$on('abrirMenu', this.abrir_menu);
	}
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.overlay-menu {
	z-index: 9;
	position: fixed;
	width: 100%;
	height: 100%;
	right: 0px;
	top: 0px;
	background-color: rgba(0, 0, 0, 0);
	visibility: hidden;
	transition: visibility 0ms linear 500ms, background-color 500ms;
}

.side-menu {
	position: absolute;
	top: 0px;
	right: 0px;
	width: 400px;
	max-width: 100%;
	height: 100%;
	background-color: rgb(255, 125, 125);
	color: white;
	// box-shadow: 0px 0px 0px 0px black;
	transform: translateX(100%);
	transition: transform 500ms;
	display: flex;
	flex-direction: column;
}

.close{
	position: absolute;
	width: 30px;
	height: 30px;
	line-height: 30px;
	border-radius: 30px;
	background-color: white;
	color: red;
	text-align: center;
	cursor: pointer;
	top: 15px;
	left: 15px;
	font-size: 20px;
	padding: 0px;
}

.encabezado {
	flex-grow: 1;
}

.subcontenidos {
	flex-grow: 2;
	overflow: auto;
}

.overlay-menu.abierto {
	visibility: visible;
	background-color: rgba(0, 0, 0, 0.6);
	transition-delay: 0s;
}

.overlay-menu.abierto > .side-menu {
	// box-shadow: 0px 0px 10px 0px black;
	transform: translateX(0px);
}

.subcontenido {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	border-bottom: 1px solid rgba(0, 0, 0, 0.6);
	margin: 10px;
	padding: 10px;
	border-radius: 10px;
	text-align: left;
}

.icono {
	background-color: white;
	color: black;
	width: 30px;
	height: 30px;
	border-radius: 50px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-left: 10px;
	margin-right: 10px;
}

.titulo {
	flex-grow: 1;
}
</style>
